<template>
  <div class="container">
    <top-menu :current="['index']"></top-menu>

    <div class="main-container">
      <div class="m-ad">
        <img
          src="https://img.haoche.cn/0/1075/space/2020-12-06/20201206172108434.jpg"
          alt=""
        />
      </div>

      <!-- 热门品牌 -->
      <h4 class="idx-title-nav">热门品牌</h4>
      <div class="homepage-heat-content__brand activate" id="tab_first">
        <router-link
          :to="{ name: 'Cars' }"
          class="homepage-heat-content__imagetext"
          v-for="brand in brands"
          v-bind:key="brand.id"
        >
          <img :src="brand.logo_url" /><br /><span>{{ brand.name }}</span>
        </router-link>

        <router-link
          :to="{ name: 'Cars' }"
          class="homepage-heat-content__imagetext"
        >
          <img src="@/assets/icons/more.png" /><br /><span>更多</span>
        </router-link>
      </div>

      <!-- 团购活动 -->
      <h4 class="idx-title-nav">团购活动</h4>
      <div class="tuangou" v-for="item in []" v-bind:key="item.id">
        <router-link
          :to="{
            name: 'Quote',
            query: {
              bname: item.brand.name,
              sname: item.name,
            },
          }"
          style="color: #333"
        >
          <div class="brandSImg flexR">
            <img :src="item.cover_url" />
          </div>
          <div class="brandSTxt">
            <div class="flexL">
              <div class="logo">
                <img
                  src="//img.kchezhan.com/uploads/content/2018-07-25/up_5b587a38082bd.png"
                />
              </div>
              <p class="f32">{{ item.brand.name }}大型团购会</p>
            </div>
            <ul class="mt-10" style="padding: 0 15px; list-style: none">
              <li class="f26 mb-10">
                特卖车系：<span class="cf33e3e">{{ item.name }}</span>
              </li>
              <li class="f26 mb-10">
                特卖时间：<span class="cf33e3e">{{ item.sale_time }}</span>
              </li>
              <li class="quote-btn">
                <p>我要询价</p>
              </li>
            </ul>
          </div>
        </router-link>
      </div>

      <div class="tg-container">
        <ul class="sale-card">
          <li v-for="item in tuans" v-bind:key="item.id">
            <router-link
              :to="{
                name: 'Quote',
                query: {
                  bname: item.brand.name,
                  sname: item.name,
                },
              }"
              style="color: #333"
            >

              <p class="card-pic">
                <img :src="item.cover_url" /></p
            ></router-link>
            <h5 class="card-title">{{ item.name }}大型团购会</h5>
            <p class="card-price">
              时间：{{item.sale_time}}
            </p>
            <router-link
              :to="{
                name: 'Quote',
                query: {
                  bname: item.brand.name,
                  sname: item.name,
                },
              }"
              style="color: #333"
              ><button class="card-btn">我要询价</button></router-link
            >
          </li>
        </ul>
      </div>

      <!-- 精选资讯 -->
      <h4 class="idx-title-nav">精选资讯</h4>
      <div class="summary-series__news">
        <div
          class="summary-series__news-card"
          v-for="item in news"
          :key="item.id"
        >
          <router-link
            :to="{ name: 'Article', params: { id: item.id } }"
            class="summary-series__news-card-a"
          >
            <div class="summary-series__news-image">
              <img :src="item.img_url" />
            </div>
            <div class="summary-series__news-caption">
              {{ item.title }}
            </div>
            <div class="summary-series__news-information">
              <div class="summary-series__news-information__assist">
                <span class="athm-card-unit-information__item">{{
                  item.published_at
                }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import TopMenu from "@/components/Menu";
import Footer from "@/components/Footer";
import { getIndexNews } from "@/api/news";
import resData from "@/data/index";
import { getTuan } from "@/api/index";

export default {
  name: "Index",
  components: {
    TopMenu,
    Footer,
  },
  data() {
    return {
      page: 1,
      limit: 10,
      news: [],
      brands: resData.brands,
      tuans: [],
    };
  },
  computed: {},
  beforeCreadted() {},
  created() {
    this.getData();
  },
  beforeDestroy() {},
  methods: {
    getData() {
      getIndexNews({ page: this.page, limit: this.limit }).then((response) => {
        this.news = response.data;
      });

      getTuan({limit:4}).then((resp) => {
        this.tuans = resp.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 800px;
  // overflow: hidden;
  margin: 0 auto;
}
.main-container {
  margin: 0.8rem;
  position: relative;
  top: 100px;
  .m-ad {
    width: 100%;
    img {
      width: 100%;
      height: 10rem;
    }
  }

  .idx-title-nav {
    margin: 1rem 0;
  }
}

// .tuangou {
//   min-height: 100px;
//   overflow: hidden;
//   background-color: #ffffff;
//   margin-bottom: 10px;
//   .brandSImg {
//     width: 100%;
//     border-radius: 0.15rem;
//     overflow: hidden;
//     img {
//       width: 100%;
//       height: auto;
//       height: 270px;
//     }
//   }

//   .brandSTxt {
//     .logo {
//       padding: 5px 10px;
//       img {
//         width: 60px;
//         height: 60px;
//         margin-right: 10px;
//       }
//     }
//   }

//   .quote-btn {
//     background: #ff4b3c;
//     color: #fff;
//     height: 36px;
//     overflow: hidden;
//     line-height: 36px;
//     border-radius: 5px;
//     margin: 10px 0px;
//     text-align: center;
//   }
// }

.tg-container {
  .sale-card {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    // padding-left: 10px;
    list-style: none;
    li:nth-child(even) {
      // margin-right: 0;
    }
    li {
      list-style: none;
      width: calc(50% - 9.5px);
      padding: 0 11px 12px 12px;
      margin-right: 9px;
      margin-bottom: 9px;
      background: #fff;
      border-radius: 4px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      a {
        display: block;
      }

      .card-pic {
        position: relative;
        margin: 0 auto;
        width: 100%;
        overflow: hidden;
        height: 90px;
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          -o-object-fit: cover;
          object-fit: cover;
        }
      }

      .card-title {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #000;
        line-height: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .card-price {
        margin-top: 7px;
        margin-bottom: 12px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #999;
        line-height: 1;
      }

      .card-btn {
        width: 100%;
        height: 32px;
        background: rgb(243, 62, 62);
        border-radius: 4px;
        border: none;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: hsla(0, 0%, 100%, 0.8);
        line-height: 1;
      }
    }
  }
}

.f32 {
  font-size: 18px;
}

.flexR {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.flexL {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.homepage-heat-content__brand {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  height: inherit;
  background: #ffffff;
  padding-bottom: 10px;
  .homepage-heat-content__imagetext {
    position: relative;
    display: block;
    width: 20%;
    font-size: 12px;
    color: #111e36;
    text-align: center;
    white-space: nowrap;
    margin-top: 10px;
    img {
      width: 36px;
      height: 36px;
      margin-bottom: 4px;
    }
    & > span {
      display: inline-block;
      vertical-align: top;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.summary-series__news-card {
  line-height: 1;
  overflow: hidden;
  background-color: #ffffff;
  margin-bottom: 15px;
  .summary-series__news-card-a {
    position: relative;
    display: block;
    padding: 12px 26px 12px 20px;
    overflow: hidden;
  }
  .summary-series__news-image {
    position: relative;
    float: right;
    width: 33.333%;
    margin: 0 -6px 0 12px;
    border-radius: 6px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      border-radius: 6px;
      -o-object-fit: cover;
      object-fit: cover;
      pointer-events: none;
    }
  }
  .summary-series__news-caption {
    max-height: 48px;
    font-size: 16px;
    color: #111e36;
    line-height: 24px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .summary-series__news-information {
    position: absolute;
    bottom: 18px;
    left: 20px;
    width: calc(66.666% - 36.666px);
    .summary-series__news-information__assist {
      position: relative;
      font-size: 1px;
      color: #666d7f;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>

